export default function useConfig() {
  const coreProducts = [
    {
      title: '司普大语言模型',
      desc: '技术实现、智能对话解决方案、智能写作解决方案、 智能搜索解决方案、 智能表格解决方案',
      brief:
        '技术实现、智能对话解决方案、智能写作解决方案、 智能搜索解决方案、 智能表格解决方案',
      id: 12
    },
    {
      title: '司普智能数采平台',
      desc: '产品优势、OCR通用内容识别、OCR医疗专业内容识别',
      brief: '产品优势、OCR通用内容识别、OCR医疗专业内容识别',
      id: 15
    }
  ]

  const solveWays = [
    {
      title: '理赔RPA'
      // icon: ''
    },
    {
      title: '医疗单位归一化'
      // icon: ''
    },
    {
      title: '理赔风控'
      // icon: ''
    },
    {
      title: '核保RPA'
      // icon: ''
    },
    {
      title: '疾病名称归一化'
      // icon: ''
    },
    {
      title: '既往史筛查'
      // icon: ''
    }
  ]

  return {
    coreProducts,
    solveWays
  }
}
